<template>
    <div class="container">
        <router-view></router-view>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'LayoutExternoBackground',
    setup() {

    },
});
</script>

<style lang="scss" scoped>

.container {
    position: relative;
    height: 100vh;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    background: url('@/assets/images/fundo_p2u.svg');
    background-color: #EFEFEF;
    background-repeat: no-repeat;
    background-position: right;
    background-size: cover; /* Ajusta o background para cobrir todo o container */
}


</style>